/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/documents_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { ApiHttpBody } from '../models'
// @ts-ignore
import { DocumentsServiceRenameDocumentBody } from '../models'
// @ts-ignore
import { DocumentsServiceSendDocumentToClientBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1Document } from '../models'
// @ts-ignore
import { V1GenerateDocumentRequest } from '../models'
// @ts-ignore
import { V1ListDocumentsResponse } from '../models'
// @ts-ignore
import { V1ListTemplatesResponse } from '../models'
// @ts-ignore
import { V1SendDocumentToClientResponse } from '../models'
/**
 * DocumentsServiceApi - axios parameter creator
 * @export
 */
export const DocumentsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceDeleteDocument: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('documentsServiceDeleteDocument', 'id', id)
      const localVarPath = `/api/v1/documents/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceDownloadDocument: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('documentsServiceDownloadDocument', 'id', id)
      const localVarPath = `/api/v1/documents/{id}/file`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {V1GenerateDocumentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceGenerateDocument: async (
      body: V1GenerateDocumentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('documentsServiceGenerateDocument', 'body', body)
      const localVarPath = `/api/v1/documents`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary wildcard GET объявлен ПЕРВЫМ (grpc-gateway prepend) — статические /documents/templates матчатся раньше. НЕ добавлять статические GET /documents/_* выше этого rpc (DEV-509).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceGetDocument: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('documentsServiceGetDocument', 'id', id)
      const localVarPath = `/api/v1/documents/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [dealId]
     * @param {string} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceListDocuments: async (
      paginationPage?: string,
      paginationPerPage?: string,
      dealId?: string,
      status?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/documents`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (dealId !== undefined) {
        localVarQueryParameter['dealId'] = dealId
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceListTemplates: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/documents/templates`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {DocumentsServiceRenameDocumentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceRenameDocument: async (
      id: string,
      body: DocumentsServiceRenameDocumentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('documentsServiceRenameDocument', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('documentsServiceRenameDocument', 'body', body)
      const localVarPath = `/api/v1/documents/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {DocumentsServiceSendDocumentToClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceSendDocumentToClient: async (
      id: string,
      body: DocumentsServiceSendDocumentToClientBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('documentsServiceSendDocumentToClient', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('documentsServiceSendDocumentToClient', 'body', body)
      const localVarPath = `/api/v1/documents/{id}/send`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * DocumentsServiceApi - functional programming interface
 * @export
 */
export const DocumentsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DocumentsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentsServiceDeleteDocument(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.documentsServiceDeleteDocument(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocumentsServiceApi.documentsServiceDeleteDocument']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentsServiceDownloadDocument(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiHttpBody>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.documentsServiceDownloadDocument(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocumentsServiceApi.documentsServiceDownloadDocument']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {V1GenerateDocumentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentsServiceGenerateDocument(
      body: V1GenerateDocumentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Document>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.documentsServiceGenerateDocument(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocumentsServiceApi.documentsServiceGenerateDocument']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary wildcard GET объявлен ПЕРВЫМ (grpc-gateway prepend) — статические /documents/templates матчатся раньше. НЕ добавлять статические GET /documents/_* выше этого rpc (DEV-509).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentsServiceGetDocument(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Document>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.documentsServiceGetDocument(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocumentsServiceApi.documentsServiceGetDocument']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [dealId]
     * @param {string} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentsServiceListDocuments(
      paginationPage?: string,
      paginationPerPage?: string,
      dealId?: string,
      status?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDocumentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.documentsServiceListDocuments(
        paginationPage,
        paginationPerPage,
        dealId,
        status,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocumentsServiceApi.documentsServiceListDocuments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentsServiceListTemplates(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListTemplatesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.documentsServiceListTemplates(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocumentsServiceApi.documentsServiceListTemplates']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {DocumentsServiceRenameDocumentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentsServiceRenameDocument(
      id: string,
      body: DocumentsServiceRenameDocumentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Document>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.documentsServiceRenameDocument(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocumentsServiceApi.documentsServiceRenameDocument']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {DocumentsServiceSendDocumentToClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentsServiceSendDocumentToClient(
      id: string,
      body: DocumentsServiceSendDocumentToClientBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SendDocumentToClientResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.documentsServiceSendDocumentToClient(id, body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocumentsServiceApi.documentsServiceSendDocumentToClient']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * DocumentsServiceApi - factory interface
 * @export
 */
export const DocumentsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DocumentsServiceApiFp(configuration)
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceDeleteDocument(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .documentsServiceDeleteDocument(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceDownloadDocument(id: string, options?: any): AxiosPromise<ApiHttpBody> {
      return localVarFp
        .documentsServiceDownloadDocument(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {V1GenerateDocumentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceGenerateDocument(
      body: V1GenerateDocumentRequest,
      options?: any,
    ): AxiosPromise<V1Document> {
      return localVarFp
        .documentsServiceGenerateDocument(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary wildcard GET объявлен ПЕРВЫМ (grpc-gateway prepend) — статические /documents/templates матчатся раньше. НЕ добавлять статические GET /documents/_* выше этого rpc (DEV-509).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceGetDocument(id: string, options?: any): AxiosPromise<V1Document> {
      return localVarFp
        .documentsServiceGetDocument(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [dealId]
     * @param {string} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceListDocuments(
      paginationPage?: string,
      paginationPerPage?: string,
      dealId?: string,
      status?: string,
      options?: any,
    ): AxiosPromise<V1ListDocumentsResponse> {
      return localVarFp
        .documentsServiceListDocuments(paginationPage, paginationPerPage, dealId, status, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceListTemplates(options?: any): AxiosPromise<V1ListTemplatesResponse> {
      return localVarFp
        .documentsServiceListTemplates(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {DocumentsServiceRenameDocumentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceRenameDocument(
      id: string,
      body: DocumentsServiceRenameDocumentBody,
      options?: any,
    ): AxiosPromise<V1Document> {
      return localVarFp
        .documentsServiceRenameDocument(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {DocumentsServiceSendDocumentToClientBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentsServiceSendDocumentToClient(
      id: string,
      body: DocumentsServiceSendDocumentToClientBody,
      options?: any,
    ): AxiosPromise<V1SendDocumentToClientResponse> {
      return localVarFp
        .documentsServiceSendDocumentToClient(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * DocumentsServiceApi - object-oriented interface
 * @export
 * @class DocumentsServiceApi
 * @extends {BaseAPI}
 */
export class DocumentsServiceApi extends BaseAPI {
  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsServiceApi
   */
  public documentsServiceDeleteDocument(id: string, options?: RawAxiosRequestConfig) {
    return DocumentsServiceApiFp(this.configuration)
      .documentsServiceDeleteDocument(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsServiceApi
   */
  public documentsServiceDownloadDocument(id: string, options?: RawAxiosRequestConfig) {
    return DocumentsServiceApiFp(this.configuration)
      .documentsServiceDownloadDocument(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {V1GenerateDocumentRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsServiceApi
   */
  public documentsServiceGenerateDocument(
    body: V1GenerateDocumentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentsServiceApiFp(this.configuration)
      .documentsServiceGenerateDocument(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary wildcard GET объявлен ПЕРВЫМ (grpc-gateway prepend) — статические /documents/templates матчатся раньше. НЕ добавлять статические GET /documents/_* выше этого rpc (DEV-509).
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsServiceApi
   */
  public documentsServiceGetDocument(id: string, options?: RawAxiosRequestConfig) {
    return DocumentsServiceApiFp(this.configuration)
      .documentsServiceGetDocument(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [dealId]
   * @param {string} [status]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsServiceApi
   */
  public documentsServiceListDocuments(
    paginationPage?: string,
    paginationPerPage?: string,
    dealId?: string,
    status?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentsServiceApiFp(this.configuration)
      .documentsServiceListDocuments(paginationPage, paginationPerPage, dealId, status, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsServiceApi
   */
  public documentsServiceListTemplates(options?: RawAxiosRequestConfig) {
    return DocumentsServiceApiFp(this.configuration)
      .documentsServiceListTemplates(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {DocumentsServiceRenameDocumentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsServiceApi
   */
  public documentsServiceRenameDocument(
    id: string,
    body: DocumentsServiceRenameDocumentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentsServiceApiFp(this.configuration)
      .documentsServiceRenameDocument(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {DocumentsServiceSendDocumentToClientBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsServiceApi
   */
  public documentsServiceSendDocumentToClient(
    id: string,
    body: DocumentsServiceSendDocumentToClientBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentsServiceApiFp(this.configuration)
      .documentsServiceSendDocumentToClient(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
